<template>
  <form @submit.prevent="submit" style="margin-bottom: 22px">
    <div class="row">
      <div class="col-sm-4">
        <label>
          Category
        </label>

        <select-widget
            v-model="filters.category"
            :nullable="true"
            :options="[{value: 'online', label: 'Online'}, {value: 'physical', label: 'Physical'}]"
            placeholder="(all)"
        />
      </div>

      <div class="col-sm-4">
        <label>
          User
        </label>

        <TypeaheadWidget
            v-model="filters.user_id"
            name="user_id"
            label="User"
            endpoint="/api/v2/users"
            :token="shared.token"
            path="data.data"
            placeholder="Search..."
            :result-label-property="row => row.attributes.full_name"
        />
      </div>

      <div class="col-sm-4">
        <label>
          New/Existing Business
        </label>

        <select-widget
            v-model="filters.is_new_business"
            :nullable="true"
            :options="[{value: 1, label: 'New Business'}, {value: 0, label: 'Existing Business'}]"
            placeholder="(all)"
        />
      </div>

      <div class="col-sm-4">
        <label>
          Starts From
        </label>

        <date-widget v-model="filters.starts_from"/>
      </div>

      <div class="col-sm-4">
        <label>
          Starts To
        </label>

        <date-widget v-model="filters.starts_to"/>
      </div>

      <div class="col-sm-4">
        <div style="margin-bottom: 5px;">&nbsp;</div>

        <button type="submit" class="btn btn-black btn-block">
          <i class="fa fa-filter"></i> Filter
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import store from '@/store'
import DateWidget from '@/vendor/forms/FormGroups/Widgets/Date'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import TypeaheadWidget from "../../../vendor/forms/FormGroups/Widgets/Typeahead.vue";

export default {
  components: {TypeaheadWidget, DateWidget, SelectWidget},

  props: {
    value: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      filters: {...this.value},

      shared: store
    }
  },

  watch: {
    value: {
      deep: true,
      handler: function (value) {
        this.filters = {...value}
      }
    }
  },

  methods: {
    submit() {
      this.$emit('input', {...this.filters})
    }
  }
}
</script>
